import React from 'react';

import { MenuItem, Menu } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import LinkIcon from '@material-ui/icons/Link';
import { deleteAgendaApi } from 'api/agenda';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { DotsIcon, StyledIcon } from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography4 } from 'uiToolkit/Typography';

const AgendaMenuOptions = ({ agendaId, menuOptions = [], onDelete, source }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e, option, agendaId) => {
    e.stopPropagation();
    setAnchorEl(null);
    switch (option) {
      case 'DELETE':
        deleteAgenda(agendaId);
        break;
      default:
        break;
    }
  };

  const deleteAgenda = async (agendaId) => {
    try {
      await deleteAgendaApi({ agendaId });
      onDelete(agendaId);
    } catch (err) {
      console.error('Error in deleting agenda : ', err);
    }
  };

  const isApplicable = (option) => menuOptions.includes(option);

  return menuOptions.length > 0 ? (
    <>
      <CircularOutlineIcon onClick={handleClick} color="primary" icon={StyledDotsIcon} />
      <StyledMenu anchorEl={anchorEl} keepMounted disablePortal open={open} onClose={handleClose}>
        {isApplicable('DELETE') && (
          <StyledMenuItem onClick={(e) => handleClose(e, 'DELETE', agendaId)}>
            <StyledIcon size="tiny" rightGutter={1} color={theme.palette.grey.dark}>
              <DeleteIcon />
            </StyledIcon>
            <Typography4 customColor={theme.palette.text.primary}>Delete</Typography4>
          </StyledMenuItem>
        )}
      </StyledMenu>
    </>
  ) : (
    <></>
  );
};

const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;

const StyledMenu = styled(Menu)`
  &.MuiPopover-root ul {
    padding: 0;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 0.75rem 1rem;
`;

const StyledLinkIcon = styled(LinkIcon)`
  transform: rotate(45deg);
`;

export default AgendaMenuOptions;
